import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { reportService } from '../../Services';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';
import {ReactComponent as Download} from '../../images/icons/General/download-cloud-02.svg';
import {ReactComponent as Printer} from '../../images/icons/Media/printer.svg';

import styles from '../../styles/components/users/letter.js';

export const AAUS = () => {
    const [year, setYear] = useState(null);
    const [yearVar, setYearVar] = useState();
    const [years, setYears] = useState();
    const [report, setReport] = useState();
    const [incidents, setIncidents] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingCsv, setLoadingCsv] = useState(false);

    const date = new Date();
    const orgName = useSelector((state) => state.org.name);

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            display: 'inline-block',
            width: '300px',
            marginRight: '10px'
          }),
        control: (provided, state) => ({
          ...provided,
          height: '42px',
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    const printReport = (e) => {
        e.preventDefault();
        
        window.frames["print_frame"].document.body.innerHTML = document.getElementById("report-title").outerHTML + document.getElementById("report").outerHTML + '<style>'+styles+'</style>';
        window.frames["print_frame"].window.focus();
        window.frames["print_frame"].window.print();
    }

    const downloadCsv = async () => {
        if (year) {
            setLoadingCsv(true);
            const date = new Date();
            const res = await reportService.AAUSReportExport(year);
            const a = document.createElement('a');
            let binaryData = [];
            binaryData.push(res);
            let url = window.URL.createObjectURL(new Blob(binaryData, {type: "text/csv"}))
            a.href = url;
            a.download = 'AAUS-Report_'+window.location.hostname+'_'+moment(date).format('YYYY-MM-DD-HH-mm')+'.csv';
            document.body.append(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setLoadingCsv(false);
        }
    };

    const handleReport = async () => {
        if (yearVar) {
            setLoading(true);
            const res = await reportService.AAUSReport(yearVar.value);
            if (res.report) {
                setYear(yearVar.value);
                setReport(res.report);
                setIncidents(res.incidents);
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        let yearsVar = []
        for (let y = 2002; y <= new Date().getFullYear(); y ++) {
            yearsVar.push({
                value: y,
                label: y
            });
        }
        setYears(yearsVar);
        setYearVar(yearsVar[yearsVar.length - 2]);
    }, [setYears]);
    return (
        <>
            <h1 id="report-title">{year ? `${orgName} ${year} AAUS Statistics Filed ${moment(date).format('YYYY-MM-DD-HH-mm')}` : 'AAUS Statistics Report for the year'}</h1>
            <div className="bordered-content">
                <div className="header">
                    <div className="select-year">
                        {years ? <Select className={`select`} options={years} onChange={setYearVar} styles={customStyles} value={yearVar} /> : ''}
                        <button className="primary" type="button" onClick={handleReport}>{loading ? <Loading className="btn-loader"alt="loader" /> : ''}Generate report</button>
                    </div>
                </div>
            </div>
            {year ? <div id="report">
                <div className="bordered-content mt-32">
                    <div className="header">
                        <div className="buttons static">
                            <button className="default" onClick={printReport}><Printer />Print</button>
                            <button className="default" onClick={downloadCsv}>{loadingCsv ? <Loading className="btn-loader" alt="loader" /> : <Download />}Download CSV</button>
                            <iframe name="print_frame" title="print_frame" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
                        </div>
                        <p><strong>Total Number of Divers logging dives during {year}: {report.TotalDivers}</strong></p>
                        <p><strong>Total Number of Dives logged during {year}: {report.TotalDives}</strong></p>
                        <p><strong>Diving Incidents This Training Cycle: {incidents}</strong></p>
                    </div>
                </div>

                <div className="bordered-content mt-32">
                    <div className="header">
                        <h4>Dives by Classification</h4>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th style={{width: '40%'}}></th>
                                <th style={{width: '20%'}}>Dive Time In Minutes</th>
                                <th style={{width: '20%'}}>Dives Logged</th>
                                <th style={{width: '20%'}}>Number of Divers<br />Logging Dives</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/sci`} target="_blank">Scientific</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Classification_Sci_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Classification_Sci_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Classification_Sci_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/trpro`} target="_blank">Training and Proficiency</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Classification_ProTr_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Classification_ProTr_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Classification_ProTr_Divers}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bordered-content mt-32">
                    <div className="header">
                        <h4>Dives by Diving Mode</h4>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th style={{width: '40%'}}></th>
                                <th style={{width: '20%'}}>Dive Time In Minutes</th>
                                <th style={{width: '20%'}}>Dives Logged</th>
                                <th style={{width: '20%'}}>Number of Divers<br />Logging Dives</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/ocs`} target="_blank">Open Circuit SCUBA</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Mode_OCS_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Mode_OCS_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Mode_OCS_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/hoo`} target="_blank">Hookah</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Mode_Hoo_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Mode_Hoo_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Mode_Hoo_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/ss`} target="_blank">Surface Supplied</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Mode_SS_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Mode_SS_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Mode_SS_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/reb`} target="_blank">Rebreather</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Mode_Reb_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Mode_Reb_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Mode_Reb_Divers}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bordered-content mt-32">
                    <div className="header">
                        <h4>Dives by Breathing Gas</h4>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th style={{width: '40%'}}></th>
                                <th style={{width: '20%'}}>Dive Time In Minutes</th>
                                <th style={{width: '20%'}}>Dives Logged</th>
                                <th style={{width: '20%'}}>Number of Divers<br />Logging Dives</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/air`} target="_blank">Air</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Gas_Air_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Gas_Air_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Gas_Air_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/nitrox`} target="_blank">Nitrox</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Gas_Nitrox_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Gas_Nitrox_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Gas_Nitrox_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/mixed`} target="_blank">Mixed Gas</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Gas_Mix_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Gas_Mix_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Gas_Mix_Divers}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bordered-content mt-32">
                    <div className="header">
                        <h4>Dives by Decompression Profiling Method</h4>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th style={{width: '40%'}}></th>
                                <th style={{width: '20%'}}>Dive Time In Minutes</th>
                                <th style={{width: '20%'}}>Dives Logged</th>
                                <th style={{width: '20%'}}>Number of Divers<br />Logging Dives</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/tables`} target="_blank">Dive Tables</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.DP_Tables_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.DP_Tables_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.DP_Tables_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/computer`} target="_blank">Dive Computer</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.DP_Computer_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.DP_Computer_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.DP_Computer_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/soft`} target="_blank">PC-based Deco Software</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.DP_Soft_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.DP_Soft_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.DP_Soft_Divers}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bordered-content mt-32">
                    <div className="header">
                        <h4>Dives by Specialized Diving Environment</h4>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th style={{width: '40%'}}></th>
                                <th style={{width: '20%'}}>Dive Time In Minutes</th>
                                <th style={{width: '20%'}}>Dives Logged</th>
                                <th style={{width: '20%'}}>Number of Divers<br />Logging Dives</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/rd`} target="_blank">Required Decompression</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.SE_RD_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.SE_RD_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.SE_RD_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/oe`} target="_blank">Overhead Environment</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.SE_OE_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.SE_OE_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.SE_OE_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/bw`} target="_blank">Blue Water</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.SE_BW_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.SE_BW_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.SE_BW_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/ip`} target="_blank">Ice/Polar</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.SE_IP_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.SE_IP_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.SE_IP_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/sd`} target="_blank">Saturation Diving</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.SE_SD_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.SE_SD_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.SE_SD_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/ad`} target="_blank">Aquarium Diving</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.SE_AD_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.SE_AD_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.SE_AD_Divers}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bordered-content mt-32">
                    <div className="header">
                        <h4>Scientific or Training/Proficiency Dives by AAUS Depth Range</h4>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th style={{width: '40%'}}></th>
                                <th style={{width: '20%'}}>Dive Time In Minutes</th>
                                <th style={{width: '20%'}}>Dives Logged</th>
                                <th style={{width: '20%'}}>Number of Divers<br />Logging Dives</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/30`} target="_blank">0 - 30 feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_30_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_30_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_30_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/60`} target="_blank">31 - 60 feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_60_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_60_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_60_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/100`} target="_blank">61 - 100 feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_100_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_100_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_100_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/130`} target="_blank">101 - 130 feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_130_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_130_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_130_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/150`} target="_blank">131 - 150 feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_150_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_150_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_150_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/190`} target="_blank">151 - 190 feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_190_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_190_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_190_Divers}</td>
                            </tr>
                            <tr>
                                <td className="mobile-bold"><Link to={`/reports/aaus/${year}/191`} target="_blank">190 - &gt; feet</Link></td>
                                <td><span className="mobile">Dive Time In Minutes: </span>{report.Depth_191_Min}</td>
                                <td><span className="mobile">Dives Logged: </span>{report.Depth_191_Dives}</td>
                                <td><span className="mobile">Number of Divers Logging Dives: </span>{report.Depth_191_Divers}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> : ''}
        </>
    );
};

export default AAUS;